import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { EntityApiDefinitionCard } from '@backstage/plugin-api-docs';

export const entityContentApiSpecification: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'api-specification',
    params: {
      path: '/api-specification',
      title: 'Specification',
      filter: { kind: 'API', 'spec.definition': { $exists: true } },
      loader: async () => <EntityApiDefinitionCard />,
    },
  });
